import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../../utils";
import { get } from "lodash";

const formName = manageDistributionFormNames.LOAN_REQUEST;
const fields = distributionFormFields[formName];

export const GetRestrictedType = (type) => {
  switch (type) {
    case 1:
      return 128;
    case 2:
      return 128;
    default:
      return 256;
  }
};

export const getDate = (date) => new Date(date);

export const getFilteredRkData = (rkData, loanSetting) => {
  const date = new Date();
  let today = new Date(date.setDate(date.getDate()));
  const restType = GetRestrictedType(loanSetting?.loanType);
  var splits = rkData.map((source) => {
    var investments = source.sourceInvestmentBalances?.filter(
      (x) =>
        !(
          get(x, "restriction.applicableTypes", []).includes(restType) &&
          getDate(x.restriction.effectiveStartDate) <= today &&
          getDate(x.restriction.effectiveEndDate) >= today
        )
    );
    return {
      sourceId: source.sourceId,
      sourceName: source.sourceName,
      vestingMultiplier: source.vestingMultiplier,
      sourceAccountBalance: source.sourceEmployeeMap.accountBalance,
      repaymentCCBBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.repaymentCCBBalance,
          0
        ) * source.vestingMultiplier,
      regularCCBBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.regularCCBBalance,
          0
        ) * source.vestingMultiplier,
      basisCCBBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.basisCCBBalance,
          0
        ) * source.vestingMultiplier,
      repaymentAccountBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.repaymentAccountBalance,
          0
        ) * source.vestingMultiplier,
      regularAccountBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.regularAccountBalance,
          0
        ) * source.vestingMultiplier,
      basisAccountBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.basisAccountBalance,
          0
        ) * source.vestingMultiplier,
      repaymentEarningsBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.repaymentEarningsBalance,
          0
        ) * source.vestingMultiplier,
      regularEarningsBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.regularEarningsBalance,
          0
        ) * source.vestingMultiplier,
      basisEarningsBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.basisEarningsBalance,
          0
        ) * source.vestingMultiplier,
      accountBalance:
        investments.reduce(
          (x, y) => x + y.sourceEmployeeInvestmentMap.accountBalance,
          0
        ) * source.vestingMultiplier,
      sourceInvestmentBalances: investments,
    };
  });

  var totalAccountBalance = splits?.reduce(
    (x, y) =>
      x +
      y.regularAccountBalance +
      y.basisAccountBalance +
      y.repaymentAccountBalance,
    0
  );
  return splits?.map((source) => {
    var accountBalance =
      (source.regularAccountBalance +
        source.basisAccountBalance +
        source.repaymentAccountBalance) *
      source.vestingMultiplier;
    return {
      ...source,
      accountBalance: accountBalance,
      sourceFraction: totalAccountBalance
        ? accountBalance / totalAccountBalance
        : 0,
      grossWithdrawalAmount: 0,
      sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
        (investment) => {
          var investmentBalance =
            investment.sourceEmployeeInvestmentMap.basisAccountBalance +
            investment.sourceEmployeeInvestmentMap.regularAccountBalance +
            investment.sourceEmployeeInvestmentMap.repaymentAccountBalance;
          return {
            ...investment.sourceEmployeeInvestmentMap,
            investmentId: investment.investmentId,
            investmentName: investment.investmentName,
            investmentAccountBalance: investmentBalance,
            investmentFraction: accountBalance
              ? (investmentBalance * source.vestingMultiplier) / accountBalance
              : 0,
            grossWithdrawalAmount: 0,
            accountBalance: investmentBalance,
          };
        }
      ),
    };
  });
};

export const getSplitForAmount = (splits, amount, label) =>
  splits?.map((source) => {
    var sourceAmount = source.sourceFraction * amount;
    if (sourceAmount != 0 && !isNaN(amount)) {
      return {
        ...source,
        [label]: sourceAmount,
        grossWithdrawalAmount:
          (source.grossWithdrawalAmount ?? 0) + sourceAmount,
        accountBalance: source.accountBalance - sourceAmount,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            var investmentAmount = sourceAmount * investment.investmentFraction;
            return {
              ...investment,
              [label]: investmentAmount,
              grossWithdrawalAmount:
                (investment.grossWithdrawalAmount ?? 0) + investmentAmount,
              accountBalance: investment.accountBalance - investmentAmount,
            };
          }
        ),
      };
    } else {
      return {
        ...source,
        [label]: 0,
        grossWithdrawalAmount: source.grossWithdrawalAmount ?? 0,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            return {
              ...investment,
              [label]: 0,
            };
          }
        ),
      };
    }
  });

export const getGrossAmount = (
  rkData,
  values,
  loanSetting,
  overnightDelivery
) => {
  var splits = getFilteredRkData(rkData, loanSetting);
  splits = getSplitForAmount(
    splits,
    values[fields.requestedAmount] ?? 0,
    fields.requestedAmount
  );
  splits = getSplitForAmount(
    splits,
    values[fields.loanFeeAmount] ?? 0,
    fields.loanFeeAmount
  );
  if (values[fields.paymentOption] == 2 || values[fields.paymentMethod] == 2)
    splits = getSplitForAmount(
      splits,
      values[fields.eftFees] ?? 0,
      fields.eftFees
    );
  if (values[fields.paymentOption] == 1 || values[fields.paymentMethod] == 1)
    splits = getSplitForAmount(
      splits,
      values[fields.chequeFees] ?? 0,
      fields.chequeFees
    );
  if (overnightDelivery)
    splits = getSplitForAmount(
      splits,
      loanSetting?.overnightDeliveryFees ?? 0,
      "overnightDeliveryFees"
    );
  return splits;
};

export const CalculateLoanSourceSplit = (
  rkData,
  values,
  loanSetting,
  overnightDelivery
) => {
  var splits = getGrossAmount(rkData, values, loanSetting, overnightDelivery);
  return splits;
};
